export default __webpack_public_path__ + "static/media/ic_thank_you.d54ea780.svg";